import gql from 'graphql-tag'

const deleteDateOrderMutation = gql`
mutation CA_Mutation_deleteDateOrderValues($id: ID!) {
	cashAssist {
		deleteDateOrderValues(id: $id) {
			id
		}
	}
}`

export default deleteDateOrderMutation
